<script setup lang="ts">
import { Coins } from 'lucide-vue-next'
import { storeToRefs } from 'pinia'
import { useUsageStore } from '@/stores/domain'

const { balance } = storeToRefs(useUsageStore())
</script>

<template>
  <RouterLink class="slot-pill" :class="{ 'slot-pill--empty': balance <= 0 }" to="/app/billing" title="Credit balance">
    <span class="slot-pill__icon"><Coins :size="15" /></span>
    <span><strong>{{ Math.round(balance).toLocaleString('en-US') }}</strong> credits</span>
  </RouterLink>
</template>
